module.exports = ".property-name {\n  font-size: 1.1em;\n  line-height: 1.6em;\n  color: black;\n  font-weight: bold;\n  cursor: pointer; }\n\n.property-address {\n  font-size: 0.8em;\n  line-height: 20px;\n  color: #3e3d3d; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/search/property-search/property-search.component.scss
// module id = ./src/app/shared/components/search/property-search/property-search.component.scss
// module chunks = main